import React from 'react';
import PropTypes from 'prop-types';
import { LG_BREAKPOINT_AND_UP, LOCATION_DATA } from 'utils/constants';
import withMediaQuery from 'utils/withMediaQuery';
import DiscoverCasinoTile from './DiscoverCasinoTile';
import DiscoverCategoryTiles from './DiscoverCategoryTiles';
import DiscoverItemList from './DiscoverItemList';
import './WStoreDiscover.css';

const WStoreDiscover = ({
  onSelectItem,
  patronAssets,
  wstoreItems,
  onSelectHotPicks,
  onSelectCategory,
  preferredLocation,
  matchesBreakpoint
}) => {
  const isDesktop = matchesBreakpoint;

  const openBookingPage = () => {
    const bookingUrl = LOCATION_DATA[preferredLocation].bookingUrl;

    if (bookingUrl) {
      window.open(bookingUrl);
    } else {
      window.open(LOCATION_DATA[preferredLocation].url);
    }
  };

  return (
    <div className="wstore-discover-container">
      <DiscoverItemList
        isDesktop={matchesBreakpoint}
        patronAssets={patronAssets}
        wstoreItems={wstoreItems}
        onSelectItem={onSelectItem}
      />
      <DiscoverCategoryTiles
        isDesktop={isDesktop}
        preferredLocation={preferredLocation}
        onSelectHotPicks={onSelectHotPicks}
        onSelectCategory={onSelectCategory}
        openBookingPage={openBookingPage}
      />
      <DiscoverCasinoTile
        preferredLocation={preferredLocation}
        openBookingPage={openBookingPage}
      />
    </div>
  );
};

WStoreDiscover.propTypes = {
  patronAssets: PropTypes.any,
  wstoreItems: PropTypes.arrayOf(PropTypes.object),
  onSelectItem: PropTypes.func,
  onSelectHotPicks: PropTypes.func,
  onSelectCategory: PropTypes.func,
  preferredLocation: PropTypes.string,
  matchesBreakpoint: PropTypes.bool
};

export default withMediaQuery(LG_BREAKPOINT_AND_UP)(WStoreDiscover);
